import { StackClientApp } from '@stackframe/react';

const projectId = process.env.REACT_APP_STACK_PROJECT_ID;
const publishableClientKey = process.env.REACT_APP_STACK_PUBLISHABLE_CLIENT_KEY;

// Only initialize if real credentials are present
export const stackApp = (projectId && publishableClientKey)
  ? new StackClientApp({
      tokenStore: 'cookie',
      projectId,
      publishableClientKey,
      urls: {
        home: '/',
        signIn: '/',
        afterSignIn: '/',
        afterSignOut: '/',
        oauthCallback: '/',
      },
    })
  : null;
